import {
  AssetChain,
  SupportedTokenBalances,
  SupportedTokenName,
} from "@mezo/sdk"
import { WalletDetailsParams } from "@rainbow-me/rainbowkit"
import { Connector } from "wagmi"

export type TokenOperation = {
  amount: bigint
  token: SupportedTokenName
}

export type WalletBalances = SupportedTokenBalances & {
  BTC: { balance: bigint; decimals: bigint; chain: AssetChain }
}

export type ExtendedConector = Connector &
  Pick<WalletDetailsParams, "rkDetails">

export type ConnectionStatus = "idle" | "pending" | "done" | "error"

export enum AccountCreationStatus {
  Idle, // No account creation in progress
  Connecting, // Wallet connection is in progress
  Connected, // Wallet is connected to dApp
  Signing, // Signing SIWW, authentication with the server
  NotSigned, // SIWW has not been signed
  Created, // Account has been created
}
